import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TrlPillContainer, TrlPillLabel } from '../TrlPill.styles';
import { TrlPillCanceledStyled } from './TrlPillCanceled.styles';

export const TrlPillCanceled = () => {
  return (
    <TrlPillContainer>
      <TrlPillCanceledStyled />
      <TrlPillLabel>
        <FormattedMessage id="TRLT_UI-CANCELLED" />
      </TrlPillLabel>
    </TrlPillContainer>
  );
};
